<template>
  <div class="eventAnalysisSearch">
    <div class="overlay" v-if="overlay"></div>
    <!-- -- {{ configData }}-- -->
    <div class="title_top_list">
      <span style="margin-bottom: 24px">
        事件配置
        <a
          href="https://lebo-corp.feishu.cn/wiki/Flm5w5888irFLjkprS7cd124n9f"
          target="_blank"
        >
          <i class="el-icon-question" style="font-size: 18px; color: #e38b1f; cursor: pointer"></i>
        </a>
      </span>
      <span> 全局筛选 </span>
    </div>

    <div class="config_box">
      <div class="event_config">
        <draggable v-model="eventList" group="items" :options="{ animation: 200 }">
          <div class="event_config_item" v-for="(item, index) in eventList" :key="index">
            <div class="item_event_name" v-show="item.editName">
              <el-input
                class="item_event_name_input"
                v-model="item.newName"
                :maxlength="33"
                placeholder="请输入事件名称"
              ></el-input>
              <el-button
                class="item_event_name_btn"
                type="text"
                @click="
                  () => {
                    item.editName = false
                    item.itemName = item.newName
                  }
                "
              >
                确定
              </el-button>
              <el-button
                class="item_event_name_btn"
                type="text"
                @click="
                  () => {
                    item.editName = false
                  }
                "
              >
                取消
              </el-button>
            </div>
            <div class="item_event_name" v-show="!item.editName">{{ item.itemName }}</div>

            <div class="event_config_item_box">
              <div class="item_title_icon">{{ setNumberToLetter(index + 1) }}</div>

              <div class="item_from">
                <custom-cascader
                  ref="custom-select"
                  :options="enventOptions"
                  placeholder="请选择事件"
                  style="width: calc(50%)"
                  v-model="item.event"
                ></custom-cascader>

                <custom-cascader
                  ref="custom-select"
                  :options="caliOptions"
                  placeholder="请选择事件"
                  style="width: calc(50%)"
                  :value="item.compute"
                  @handleChange="
                    (val) => {
                      item.compute = val
                    }
                  "
                ></custom-cascader>
              </div>

              <div class="item_btn">
                <el-tooltip content="添加过滤条件" placement="top">
                  <el-button
                    type="text"
                    icon="el-icon-zoom-in"
                    @click="
                      item.filters.push({ attr: '', val: '', opt: '', eventValLoading: false, attrValOptions: [] })
                    "
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="修改名称" placement="top">
                  <el-button type="text" icon="el-icon-edit" @click="item.editName = true"></el-button
                  ></el-tooltip>
                <el-tooltip content="复制" placement="top">
                  <el-button type="text" icon="el-icon-copy-document" @click="copyRow(eventList, item)"></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="text"
                    v-if="index !== 0"
                    icon="el-icon-delete"
                    @click="deleteRow(index, eventList)"
                  ></el-button>
                </el-tooltip>
              </div>
            </div>

            <div class="item_box_attribute">
              <div class="link_icon" v-if="Array.isArray(item.filters) && item.filters.length > 1">AND</div>

              <div class="_attribute_item">
                <div class="_attribute_item_li" v-for="(andItem, andIndex) in item.filters" :key="andIndex">
                  <div class="_attribute_item_li_select">
                    <custom-cascader
                      :options="attrOptions"
                      v-loading="andItem.eventValLoading"
                      ref="custom-select"
                      :disabled="!item.event"
                      placeholder="请选择属性"
                      style="width: calc(50% - 62px)"
                      v-model="andItem.attr"
                      @typeModel="(type) => (andItem.type = type)"
                      @input="
                        () => {
                          andItem.val = []
                          andItem.opt = ''
                          // 如果是用户分群，个人分群，公共分群
                          let params = {}
                          if (andItem.type === '用户分群') {
                            params.userid = andItem.attr === '个人分群' ? userid : ''
                          } else {
                            params.item = andItem.attr
                          }
                          andItem.eventValLoading = true
                          const API = andItem.type === '用户分群' ? get_theme_attr_val : get_attr_val
                          API(params)
                            .then((res) => {
                              andItem.eventValLoading = false
                              let list = res.data.map((item) => {
                                return { label: item.description, value: item.val }
                              })
                              if (list.length) {
                                andItem.attrValOptions = list.filter((_item) => _item)
                              } else {
                                andItem.attrValOptions = []
                              }
                              andItem.eventValLoading = false
                            })
                            .catch(() => {
                              andItem.eventValLoading = false
                              andItem.attrValOptions = []
                            })
                        }
                      "
                    ></custom-cascader>
                    <custom-select
                      :options="
                        andItem.type === '用户分群'
                          ? [
                              { value: 'in', label: 'in' },
                              { value: 'not in', label: 'not in' }
                            ]
                          : optOptions
                      "
                      ref="custom-select"
                      :disabled="!item.event || !item.compute"
                      placeholder="请选择"
                      style="width: 92px; margin: 0 16px"
                      v-model="andItem.opt"
                    ></custom-select>
                    <span v-show="false">
                      ++{{ andItem.attrValOptions ? andItem.attrValOptions.length : 'nodata' }}++{{
                        andItem.eventValLoading
                      }}</span
                    >
                    <custom-select
                      v-if="andItem.opt != '为空' && andItem.opt != '非空' && andItem.opt != '不为空'"
                      :options="andItem.attrValOptions"
                      v-loading="andItem.eventValLoading"
                      ref="custom-select"
                      :disabled="!item.event || !item.compute"
                      multiple
                      placeholder="请选择属性值"
                      style="width: calc(50% - 62px)"
                      v-model="andItem.val"
                    ></custom-select>
                  </div>
                  <el-tooltip content="删除" placement="top">
                    <el-button
                      type="text"
                      style="margin-left: 12px; margin-top: -20px"
                      icon="el-icon-delete"
                      @click="deleteRow(andIndex, item.filters)"
                    ></el-button>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </draggable>
        <div class="add_event_config_btn" style="margin-top: 0">
          <el-button
            style="padding: 12px 40px"
            @click="
              eventList.push({
                name: '',
                editName: false,
                newName: '',
                event: '',
                compute: '',
                logic: 'AND',
                filters: []
              })
            "
            type="primary"
          >添加事件</el-button
          >
        </div>

        <div class="eventCalculation_box">
          <div class="eventCalculation_box_ul" v-for="(item, index) in eventCalculation" :key="index">
            <div class="eventCalculation_name" v-show="item.editName">
              <el-input
                class="eventCalculation_name_input"
                v-model="item.newName"
                :maxlength="33"
                placeholder="请输入事件名称"
              ></el-input>
              <el-button
                class="eventCalculation_name_btn"
                type="text"
                @click="
                  () => {
                    item.editName = false
                    item.name = item.newName
                  }
                "
              >
                确定
              </el-button>
              <el-button
                class="eventCalculation_name_btn"
                type="text"
                @click="
                  () => {
                    item.editName = false
                  }
                "
              >
                取消
              </el-button>
            </div>
            <div class="eventCalculation_name" v-show="!item.editName">{{ item.name }}</div>

            <div class="eventCalculation_box_item">
              <div class="_num">{{ index + 1 }}</div>

              <el-form style="width: calc(100% - 180px)" :model="item" ref="eventCalculationVal" :rules="rules">
                <el-form-item prop="val">
                  <el-input v-model="item.val" placeholder="B/A" class="eventCalculation_box_item_input"></el-input>
                </el-form-item>
              </el-form>

              <custom-select
                :options="eventCalculationType"
                ref="custom-select"
                placeholder="请选择"
                class="eventCalculation_box_item_select"
                v-model="item.preci"
              ></custom-select>

              <div class="eventCalculation_box_item_btn">
                <el-tooltip content="复制" placement="top">
                  <el-button
                    type="text"
                    icon="el-icon-copy-document"
                    @click="copyRow(eventCalculation, item)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="修改名称" placement="top">
                  <el-button type="text" icon="el-icon-edit" @click="item.editName = true"></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button type="text" icon="el-icon-delete" @click="deleteRow(index, eventCalculation)"></el-button>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右边 全局筛选 -->
      <div class="global_config">
        <div class="removal_height">
          <div class="global_config_icon" v-show="Array.isArray(global) && global.length > 1">AND</div>

          <div
            class="global_config_box"
            :style="`border-left: ${Array.isArray(global) && global.length > 1 ? '2px solid #e0e3e6' : 'none'};`"
          >
            <div class="global_config_item" v-for="(item, index) in global" :key="index">
              <div class="global_config_item_li_select">
                <custom-cascader
                  :options="attrOptions"
                  v-loading="item.eventValLoading"
                  ref="custom-select"
                  placeholder="请选择属性"
                  style="width: calc(50% - 62px)"
                  v-model="item.attr"
                  @typeModel="(type) => (item.type = type)"
                  @input="
                    () => {
                      item.val = []
                      // 如果是用户分群，个人分群，公共分群
                      let params = {}
                      item.opt = ''
                      if (item.type && item.type === '用户分群') {
                        params.userid = item.attr === '个人分群' ? userid : ''
                      } else {
                        params.item = item.attr
                      }
                      item.eventValLoading = true
                      const API = item.type === '用户分群' ? get_theme_attr_val : get_attr_val
                      API(params)
                        .then((res) => {
                          item.eventValLoading = false
                          item.attrValOptions = res.data.map((_item) => {
                            return { label: _item.description, value: _item.val }
                          })
                        })
                        .catch(() => {
                          item.eventValLoading = false
                          item.attrValOptions = []
                        })
                    }
                  "
                ></custom-cascader>

                <custom-select
                  :options="
                    item.type === '用户分群'
                      ? [
                          { value: 'in', label: 'in' },
                          { value: 'not in', label: 'not in' }
                        ]
                      : optOptions
                  "
                  ref="custom-select"
                  placeholder="请选择"
                  style="width: 92px; margin: 0 16px"
                  v-model="item.opt"
                ></custom-select>

                <custom-select
                  :options="item.attrValOptions"
                  v-if="item.opt != '为空' && item.opt != '非空' && item.opt != '不为空'"
                  v-loading="item.eventValLoading"
                  multiple
                  ref="custom-select"
                  placeholder="请选择属性值"
                  style="width: calc(50% - 62px)"
                  v-model="item.val"
                ></custom-select>
              </div>
              <el-tooltip content="删除" placement="top">
                <el-button
                  type="text"
                  style="margin-left: 12px; margin-top: -20px"
                  icon="el-icon-delete"
                  @click="deleteRow(index, global)"
                ></el-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <div class="add_event_config_btn">
          <el-button
            style="padding: 12px 40px"
            @click="global.push({ attr: '', val: '', opt: '', attrValOptions: [] })"
            type="primary"
          >添加条件</el-button
          >
        </div>

        <div class="attributive_grouping_btn" v-if="groupingAttribute">
          <el-button
            style="padding: 12px 20px"
            @click="groupingList.push({ val: '', name: '', groupingName: '', newName: '', editName: false })"
            icon="el-icon-plus"
          >属性分组</el-button
          >
        </div>
        <div>
          <div
            style="margin-top: 15px; background-color: #f4f4f4; border-radius: 5px; padding: 10px 10px 0"
            v-for="(item, index) in groupingList"
            :key="index"
          >
            <div v-show="item.editName" style="display: flex; padding-bottom: 10px">
              <el-input
                v-model.trim="item.newName"
                style="width: 75%"
                :maxlength="32"
                placeholder="请输入分组名称"
              ></el-input>
              <el-button
                type="text"
                style="margin-left: 12px"
                @click="
                  () => {
                    item.editName = false
                    item.groupingName = item.newName
                  }
                "
              >
                确定
              </el-button>
              <el-button
                c
                type="text"
                @click="
                  () => {
                    item.editName = false
                  }
                "
              >
                取消
              </el-button>
            </div>
            <div v-show="!item.editName" style="padding-bottom: 10px">{{ item.groupingName }}</div>

            <div>
              <custom-select
                :options="groupOptions"
                ref="custom-select"
                style="width: 80%"
                placeholder="请选择"
                v-model="item.val"
                @input="
                  () => {
                    setName(val, index)
                  }
                "
              ></custom-select>
              <el-tooltip content="修改名称" placement="top">
                <el-button
                  type="text"
                  style="margin-left: 12px"
                  icon="el-icon-edit"
                  @click="item.editName = true"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="删除" placement="top">
                <el-button
                  type="text"
                  style="margin-left: 12px"
                  icon="el-icon-delete"
                  @click="deleteRow(index, groupingList)"
                ></el-button>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSelect from '../CustomSelect.vue'
import CustomCascader from '../CustomCascader.vue'

import {
  get_envent_enum,
  get_cali_enum,
  get_opt_enum,
  get_attr_enum_tmp,
  get_theme_attr_val,
  get_attr_val,
  get_group_enum
} from '@/api/bigData/relationAnalysis'
import draggable from 'vuedraggable'
const checkString = (str) => {
  let hasLetter = false
  let hasOperator = false

  // 判断字符串中是否包含字母和运算符号
  for (let i = 0; i < str.length; i++) {
    if (/[a-zA-Z]/.test(str[i])) {
      hasLetter = true
    }
    if (/[+\-*/]/.test(str[i])) {
      hasOperator = true
    }
  }

  // 返回判断结果
  return hasLetter && hasOperator
}

// // 函数判断字符串是否包含
const containsValue = (str) => {
  // 使用正则表达式匹配字符串中是否有"val"
  let is = true
  let list = document.querySelectorAll('.item_title_icon')
  let arr = []
  list.forEach((item) => arr.push(item.textContent.trim()))
  let letters = str.match(/[A-Z]/g) // 使用正则表达式匹配字母字符，并返回一个新数组
  for (let i = 0; i < letters.length; i++) {
    let char = letters[i]
    if (arr.indexOf(char) === -1) {
      is = false
    }
  }
  return is
}

// 校验事件计算
const validatePass = (rule, value, callback) => {
  console.log('value', value)
  // 非空判断
  if (value.trim() == '') {
    callback(new Error('请输入有效内容！'))
  }
  // 校验内容格式：当输入内容格式不符时，提示：含有非法字符，请输入字母、数字或运算符号
  // 将中文括号替换为英文括号
  let sanitizedValue = value.replace(/（/g, '(').replace(/）/g, ')')
  // 使用正则表达式去除除了字母、数字、+、-、*、/、()之外的字符
  // eslint-disable-next-line no-useless-escape
  sanitizedValue = sanitizedValue.replace(/[^a-zA-Z0-9\+\-\*\/\(\)]/g, '')
  if (value !== sanitizedValue) {
    callback(new Error('含有非法字符，请输入字母、数字或运算符号!'))
    return
  }
  // 校验必须包含的字符：必须包含至少一个字母和一个运算符号（+、-、*、/）
  if (!checkString(value)) {
    callback(new Error('必须包含至少一个字母和一个运算符号（+、-、*、/）'))
    return
  }

  if (!containsValue(value)) {
    callback(new Error('事件不存在，请输入正确的事件ID'))
    return
  }

  callback()
}
console.log(validatePass)
export default {
  components: {
    CustomSelect,
    draggable,
    CustomCascader
  },
  name: 'eventAnalysisSearch',
  props: {
    configData: {
      type: Object,
      default: () => {}
    },
    groupingAttribute: {
      type: Boolean,
      default: true
    },
    eputmeter: {
      type: Boolean,
      default: true
    },
    overlay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userid: '',
      get_attr_val: {},
      get_theme_attr_val: {},
      groupingList: [
        // {
        //   name: '',
        //   val: ''
        // }
      ], // 属性分组
      rules: {
        val: [
          // { validator: validatePass, trigger: 'blur' }, // 复杂校验
          { required: true, message: '内容不可为空', trigger: 'blur' } // 简单校验
        ]
      },
      eventRules: {
        compute: [{ required: true, message: '内容不可为空', trigger: 'change' }]
      },
      eventList: [
        // { // 事件
        //   name: '',
        //   editName: false, //是否编辑name
        //   newName: '', // 编辑之后的name
        //   event: '', //事件
        //   compute: '',//口径
        //   logic: 'AND',
        //   filters: [
        //     {
        //       attrValOptions: [], // 属性值
        //       attr: '',
        //       val: '',
        //       opt: '',
        //     }
        //   ]
        // }
      ],
      global: [
        // 全局
        // {
        //   attr: '',
        //   val: [],
        //   opt: '',
        //   attrValOptions: [], // 属性值
        // }
      ],
      eventCalculation: [
        // { val: '', preci: '', name: '', newName: '', editName: false, }
      ], // 事件计算

      enventOptions: [], // 1获取事件类型列表
      caliOptions: [], // 2获取口径列表
      optOptions: [], // 3获取运算符
      attrOptions: [], // 4获取事件属性列表
      attrValOptions: [], // 5获取某个事件属性的值列表
      groupOptions: [], // 6获取分组列表

      eventCalculationType: [
        {
          value: '1',
          label: '数字'
        },
        {
          value: '2',
          label: '数字（小数'
        },
        {
          value: '3',
          label: '百分比'
        },
        {
          value: '4',
          label: '百分比（小数'
        }
      ]
    }
  },
  watch: {
    data: {
      handler(val) {
        console.log(val)
        this.get_attr_val = get_attr_val
        this.initConfigData()
        this.initSearchData()
      },
      deep: true
    }
  },

  created() {
    console.log('$route.query', this.$route.path)
    this.get_attr_val = get_attr_val
    this.get_theme_attr_val = get_theme_attr_val
    this.userid = JSON.parse(window.localStorage.getItem('lebo-userInfo')).content.user_id
    this.initSearchData()
  },
  methods: {
    // 校验页面
    validateDom(callback) {
      let isList = []

      let domList = this.$refs['custom-select'] || []
      domList.forEach((item) => {
        item.itemValidate((res) => {
          console.log('callback--', res)
          isList.push(res)
        })
      })

      let cascadeDom = this.$refs['el-cascade'] || []
      cascadeDom.forEach((item) => {
        item.validate((res) => {
          isList.push(res)
          console.log('callback--cascadeDom', res)
        })
      })

      let eventCalculationValDom = this.$refs['eventCalculationVal'] || []
      console.log('eventCalculationVal', eventCalculationValDom)
      eventCalculationValDom.forEach((item) => {
        item.validate((res) => {
          isList.push(res)
          console.log('callback--eventCalculationValDom', res)
        })
      })

      let is = isList.every((item) => item === true)

      callback(is)
    },

    initConfigData() {
      if (Object.keys(this.configData).length !== 0) {
        this.eventList = this.configData.eventList || []
        this.global = this.configData.global || []
        this.groupingList = this.configData.groupingList || []
        this.eventCalculation = this.configData.eventCalculation || []

        // 初始化兼容老数据没有相应字段
        this.groupingList = this.groupingList.map((item) => {
          return {
            val: item.val || '',
            name: item.name || '',
            groupingName: item.groupingName || '',
            newName: item.newName || '',
            editName: false
          }
        })
      }
      console.log('this.configData------------------------------------->>>>>', this.configData)
    },
    setName(val, index) {
      let data = this.groupOptions.filter((_item) => {
        return _item.value == val
      })
      console.log('setName', data)
      this.groupingList[index].name = data.length ? data[0].label : ''
    },
    // 初始化查询枚举参数
    initSearchData() {
      // 1获取事件类型列表
      get_envent_enum().then((res) => {
        console.log('1获取事件类型列表------', res)
        this.initConfigData()

        this.enventOptions = this.createEnventTreeData(res.data)
      })
      // 2获取口径列表
      get_cali_enum().then((res) => {
        console.log('2获取口径列表------', res)
        this.initConfigData()
        let list = res.data.map((item) => {
          return {
            show_col_name: item.show_name,
            col_name: item.show_name,
            val: item.val
          }
        })
        this.caliOptions = this.createCaliOptionsTreeData(list)
        console.log('this.createCaliOptionsTreeData---------->>>', this.caliOptions)
      })
      // 3获取运算符
      get_opt_enum().then((res) => {
        console.log('3获取运算符------', res)
        this.initConfigData()
        this.optOptions = res.data.map((item) => {
          return {
            label: item,
            value: item
          }
        })
      })
      // 4获取事件属性列表
      get_attr_enum_tmp().then((res) => {
        console.log('4获取事件属性列表------', res)
        this.initConfigData()
        this.attrOptions = this.createTreeData(res.data)
      })
      get_group_enum().then((res) => {
        console.log('6获取分组列表------', res)
        this.initConfigData()
        this.groupOptions = res.data.map((item) => {
          return {
            label: item.description,
            value: item.group
          }
        })
      })
    },
    // 格式化caliOptions数据
    createCaliOptionsTreeData(tree) {
      return tree.map((item) => {
        const newNode = {
          value: item.col_name,
          label: item.show_col_name
        }
        if (item.val && item.val.length > 0) {
          newNode.children = this.createCaliOptionsTreeData(item.val)
        }
        return newNode
      })
    },
    // 格式化树形数据
    createEnventTreeData(array) {
      const treeData = []
      const map = {}

      array.forEach((item) => {
        const { type, val, description } = item
        // label: item.description,
        // value: item.val
        if (!map[type]) {
          map[type] = {
            label: type || '暂无',
            value: type || '暂无',
            type: type || '暂无',
            children: []
          }
          treeData.push(map[type])
        }

        const child = {
          label: description || val,
          value: val,
          type: type
        }
        map[type].children.push(child)
      })

      return treeData
    },

    // 格式化树形数据
    createTreeData(array) {
      const treeData = []
      const map = {}

      array.forEach((item) => {
        const { rawtype, rawname, description } = item
        // label: item.description,
        // value: item.rawname
        if (!map[rawtype]) {
          map[rawtype] = {
            label: rawtype || '暂无',
            value: rawtype || '暂无',
            rawtype: rawtype || '暂无',
            children: []
          }
          treeData.push(map[rawtype])
        }

        const child = {
          label: description || rawname,
          value: rawname,
          rawtype: rawtype
        }
        map[rawtype].children.push(child)
      })

      return treeData
    },

    // 删除行
    deleteRow(index, row) {
      row.splice(index, 1)
    },
    // 复制行
    copyRow(row, item) {
      let data = JSON.parse(JSON.stringify(item))
      row.push(data)
    },
    setNumberToLetter(i) {
      let data = this.numberToLetter(i)
      this.eventList[i - 1].name = data
      return data
    },
    numberToLetter(number) {
      if (number < 1 || number > 999) {
        return 'nall~'
      }
      const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      if (number <= 26) {
        return letters.charAt(number - 1)
      } else if (number <= 676) {
        const firstLetter = letters.charAt(Math.floor((number - 1) / 26) - 1)
        const secondLetter = letters.charAt((number - 1) % 26)
        return firstLetter + secondLetter
      } else {
        const firstLetter = letters.charAt(Math.floor((number - 1) / 676) - 1)
        const secondLetter = letters.charAt(Math.floor(((number - 1) % 676) / 26))
        const thirdLetter = letters.charAt((number - 1) % 26)
        return firstLetter + secondLetter + thirdLetter
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.eventAnalysisSearch {
  position: relative;

  /deep/ .el-loading-mask {
    margin-top: -15px;
  }

  margin-top: 24px;
  box-sizing: border-box;

  .title_top_list {
    display: flex;
    justify-content: space-between;

    span {
      vertical-align: middle;
      line-height: 1;
      width: 50%;

      &:first-child {
        width: calc(50% + 120px);
      }
    }
  }

  .config_box {
    display: flex;
    justify-content: space-between;

    .event_config {
      width: calc(50% - 50px);

      .event_config_item {
        margin-bottom: 20px;
        background-color: #cccccc2f;
        padding: 10px;
        border-radius: 5px;

        .item_event_name {
          width: 85%;
          display: flex;

          .item_event_name_input {
            margin-right: 24px;
          }

          .item_event_name_btn {
            font-size: 14px;
          }
        }

        .event_config_item_box {
          display: flex;
          margin: 16px 0;

          .item_title_icon {
            border-radius: 5px 0 0 5px;
            height: 38px;
            line-height: 38px;
            width: 40px;
            text-align: center;
            background-color: #f4f6f9;
            font-size: 18px;
            border: 1px solid #ccc;
            z-index: 1;
          }

          .item_from {
            flex: 1;
          }

          .item_from_select_1 {
            margin-left: -2px;
            width: 50%;
          }

          .item_from_select_2 {
            display: inline-block;
            margin-left: -2px;
            width: 50%;

            /deep/ .el-input__inner {
              border-radius: 0 4px 4px 0;
            }
          }

          .item_btn {
            margin-left: 12px;
          }
        }

        .item_box_attribute {
          display: flex;
          align-items: center;

          .link_icon {
            border: 1px solid #ccc;
            background-color: #f0f0f0;
            border-radius: 10px;
            padding: 5px 10px;
            color: #5b93fc;
            z-index: 1;
          }
        }

        ._attribute_item {
          padding-left: 50px;
          border-radius: 0 0 0 40px;
          border-left: 2px solid #e0e3e6;
          margin-left: -30px;
          width: calc(100% - 160px);

          ._attribute_item_li {
            display: flex;
            margin-top: 16px;

            &:first-child {
              margin-top: 0;
            }

            ._attribute_item_li_select {
              width: 100%;
            }
          }
        }
      }

      .add_event_config_btn {
        margin-top: 24px;
      }

      .eventCalculation_box {
        margin-top: 16px;

        .eventCalculation_box_ul {
          background-color: #cccccc2f;
          padding: 10px 10px 0 10px;
          border-radius: 5px;
          margin-bottom: 16px;

          .eventCalculation_name {
            display: flex;
            width: 85%;
            margin-bottom: 8px;

            .eventCalculation_name_input {
              margin-right: 24px;
            }
          }
        }

        .eventCalculation_box_item {
          display: flex;

          ._num {
            border-radius: 5px 0 0 5px;
            height: 38px;
            line-height: 38px;
            width: 40px;
            text-align: center;
            background-color: #f4f6f9;
            font-size: 18px;
            border: 1px solid #ccc;
            z-index: 2;
          }

          .eventCalculation_box_item_input {
            margin-left: -2px;
            width: 100%;
            z-index: 3;

            /deep/ .el-input__inner {
              border-radius: 0;
            }
          }

          .eventCalculation_box_item_select {
            margin-left: -2px;
            width: 175px;
          }

          .eventCalculation_box_item_btn {
            margin-left: 16px;
            width: 100px;
          }
        }
      }
    }

    .global_config {
      width: calc(50% - 50px);

      .removal_height {
        display: flex;
        align-items: center;
        margin-bottom: 24px;
      }

      .global_config_icon {
        border: 1px solid #ccc;
        background-color: #f0f0f0;
        border-radius: 10px;
        padding: 5px 10px;
        color: #5b93fc;
        z-index: 1;
        height: 20px;
      }

      .global_config_box {
        border-radius: 40px 0 0 40px;
        border-left: 2px solid #e0e3e6;
        margin-left: -30px;
        padding-left: 50px;
        width: calc(100% - 50px);
        height: 100%;

        .global_config_item {
          display: flex;
          margin-top: 16px;

          .global_config_item_li_select {
            width: 100%;
          }

          &:first-child {
            margin-top: 0;
          }
        }
      }
    }
  }

  .attributive_grouping_btn {
    margin-top: 100px;
  }

  .attributive_grouping_box {
    background-color: pink;
  }
}

.overlay {
  position: absolute; /* 或者absolute，根据需要决定 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0); /* 调整最后一个值来改变透明度 */
  z-index: 10; /* 确保蒙层覆盖其他内容 */
}

/deep/ .el-input {
  width: 100% !important;
}
</style>
